/** 租户预览模式：用 sessionStorage 按标签页隔离，避免「新窗口查看」污染原窗口 */

const ID_KEY = 'preview_tenant_admin_id'
const TEL_KEY = 'preview_tenant_tel'

export const getPreviewTenantAdminId = (): string =>
  sessionStorage.getItem(ID_KEY) || localStorage.getItem(ID_KEY) || ''

export const getPreviewTenantTel = (): string =>
  sessionStorage.getItem(TEL_KEY) || localStorage.getItem(TEL_KEY) || ''

export const setPreviewTenant = (id: string, tel: string) => {
  sessionStorage.setItem(ID_KEY, id)
  sessionStorage.setItem(TEL_KEY, tel || '')
  // 清掉历史 localStorage，避免跨标签串扰
  localStorage.removeItem(ID_KEY)
  localStorage.removeItem(TEL_KEY)
}

export const clearPreviewTenant = () => {
  sessionStorage.removeItem(ID_KEY)
  sessionStorage.removeItem(TEL_KEY)
  localStorage.removeItem(ID_KEY)
  localStorage.removeItem(TEL_KEY)
}

/** 从入口 URL query 接管预览参数（新窗口打开场景），并清理地址栏 */
export const consumePreviewTenantFromUrl = () => {
  try {
    const url = new URL(window.location.href)
    const id = url.searchParams.get(ID_KEY)
    const tel = url.searchParams.get(TEL_KEY)
    if (!id) return
    setPreviewTenant(id, tel || '')
    url.searchParams.delete(ID_KEY)
    url.searchParams.delete(TEL_KEY)
    const next = `${url.pathname}${url.search}${url.hash}`
    window.history.replaceState(null, '', next)
  } catch {
    // ignore
  }
}

/** 打开带预览参数的新窗口（首页） */
export const openPreviewTenantWindow = (id: string | number, tel: string) => {
  const url = new URL(window.location.href)
  url.search = ''
  url.hash = '#/'
  url.searchParams.set(ID_KEY, String(id))
  url.searchParams.set(TEL_KEY, tel || '')
  window.open(url.toString(), '_blank')
}
